import styled from '@emotion/styled';

export const ProductWrapper = styled.div`
  display: flex;
  margin-bottom: 16px;
`;

export const ProductImageWrapper = styled.div`
  margin-right: 15px;
  img {
    width: 180px;
  }
`;

export const ProductDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const PartNumber = styled.p`
  margin: 0;
  margin-bottom: 4px;
  line-height: 150%;
  font-size: 15px;
  font-weight: bold;
`;

export const PartDescription = styled.p`
  margin: 0;
  margin-bottom: 16px;
  line-height: 150%;
  font-size: 14px;
`;

export const ProductPrice = styled.p`
  margin: 0;
  margin-bottom: 10px;
`;

export const StatusMessage = styled.ul`
  margin: 0;
  padding-left: 15px;

  &.status-success {
    color: ${({ theme }) => theme.colors.success};
  }

  &.status-danger {
    color: ${({ theme }) => theme.colors.danger};
  }
`;
